import { selectAdditionalItemType } from '@src/types';

export const CONTRACTOR_LOS_ORDER = [
  'Ambulatory',
  'Ambulatory Curb to Curb',
  'Ambulatory Door to Door',
  'Mileage Reimbursement',
  'Mass Transit',
  'NEMT Ground',
  'Paratransit',
  'Wheelchair',
  'Gurney',
  'NEMT Ambulance',
  'Basic Life Support',
  'Advanced Life Support',
  'Specialty Care Transport',
  'NEMT Air',
  'Fixed Wing',
  'Rotary Wing',
];

const normalizeLosLabel = (value?: string | null) =>
  (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

const getLosOrderMap = () =>
  new Map(
    CONTRACTOR_LOS_ORDER.map((label, index) => [
      normalizeLosLabel(label),
      index,
    ])
  );

export const getOrderedLosOptions = (
  options?: Array<selectAdditionalItemType> | null
) => {
  if (!options?.length) return [];

  const orderMap = getLosOrderMap();
  const uniqueOptions = new Map<string, selectAdditionalItemType>();

  options.forEach((option) => {
    const optionKey = normalizeLosLabel(option?.label || option?.value);

    if (uniqueOptions.has(optionKey)) {
      return;
    }

    if (!orderMap.has(optionKey)) {
      return;
    }

    uniqueOptions.set(optionKey, option);
  });

  return [...uniqueOptions.values()].sort((left, right) => {
    const leftIndex =
      orderMap.get(normalizeLosLabel(left?.label || left?.value)) ?? Infinity;
    const rightIndex =
      orderMap.get(normalizeLosLabel(right?.label || right?.value)) ?? Infinity;

    return leftIndex - rightIndex;
  });
};
